import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { Checkbox, Flex, Input, Row, Typography} from "antd"
import { IconLogoBlack } from "components/assets/icons";
import { FillButton } from "components/elements";
import { BaseContainer } from "components/containers";
import { getLocalStorage, } from "hooks/useLocalStorage";
import { loginAPI } from "api/common";
import { useAuth } from 'hooks/AuthContext';
import { useTableContext } from 'hooks/MenuTableAuthContext';

export default function Login ({ common }) {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(getLocalStorage('userId')?getLocalStorage('userId'):"");
  const [userPw, setUserPw] = useState('');
  const [save, setSave] = useState(getLocalStorage('userId')?true:false);
  const [err, setErr] = useState({id:{status: "" }, userPw:{status: ""}})
  const { fnOpenMenuInfo } = useTableContext() || {};
  const { login } = useAuth();

  const handleKeyDown =  (event) => {
    if (event.key == 'Enter') {
      handleLogin();
    }
  }
  useEffect(()=>{
    window.localStorage.removeItem('persist:user');
    window.localStorage.removeItem('userMenu');
    window.localStorage.removeItem('openMenuInfo');
    window.localStorage.removeItem('col');
  },[])

  const handleLogin = async () => {
    if(!userId) {
      setErr({...err, id:{status:'error'}})
      return
    }
    if(!userPw) {
      setErr({...err, userPw:{status:'error'}})
      return
    }
    
    const data = {
      user_id: userId,
      user_pw: userPw
    }
    try {
      const res = await loginAPI(data);
      if(res?.status === 200){
        await login(res.data.data_info,save);
        let nav = ''
        if(res.data.data_info.level_no === 1) {
          nav = '/admin/dashboard';
        }
        if(res.data.data_info.level_no === 2) {
          nav = '/branch/dashboard';
        }
        if(res.data.data_info.level_no === 3) {
          nav = '/school/member/manage';
        }
        if(res.data.data_info.level_no === 4) {
          nav = '/school/member/manage';
        }
        if(res.data.data_info.level_no === 5) {
          nav = '/sptpManager/sptp/manage';
        }
        if(res.data.data_info.level_no === 6) {
          nav = '/post/goods';
        }
        const findFirstMenuInfo = (res.data.data_info.menu_list).filter(it=>it.MENU_URL===nav);
        fnOpenMenuInfo({id:findFirstMenuInfo.IDX, code:findFirstMenuInfo.DEPTH2_MENU_CD, url:findFirstMenuInfo.MENU_URL});
        navigate(nav, {replace: true});
      }else{
        alert('아이디 또는 비밀번호를 확인해주세요.')
      }
    }catch(err){
      alert('아이디 또는 비밀번호를 확인해주세요!')
      console.log(err);
    }
  }


  return (
    <Row justify={'center'} align='middle' style={{ height: '100vh', backgroundColor:'var(--color-qmir-navy)'}}>
        <BaseContainer width='450px' height='370px'>
          <Flex vertical gap='large' style={{margin:'4rem'}}>
            <Flex gap='11px' align='center' justify="center">
              <IconLogoBlack />
              <Typography.Title level={4} style={{marginBottom:'initial'}}>큐미르 인트라넷</Typography.Title>
            </Flex>
            <Input 
                placeholder="ID" 
                {...err.id}
                value={userId}
                onKeyDown={handleKeyDown}
                onChange={(e) => setUserId(e.target.value)}
                />
            <Flex vertical gap='small'>
              <Input.Password
                  placeholder="PW" 
                  {...err.userPw}
                  value={userPw}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => setUserPw(e.target.value)}
                  />
              <Checkbox checked={save} onClick={()=>setSave(!save)}>아이디 저장</Checkbox>
            </Flex>
            <Flex vertical gap='small' align='center'>
              <FillButton label="로그인" onClick={handleLogin} width='100%'/>
              <Typography.Text type="secondary">로그인 관련 문의는 관리자에게 문의하세요.</Typography.Text>
            </Flex>
          </Flex>
        </BaseContainer>
      </Row>
  )
}